import React, { useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";
import convertToExcel from "../../../../components/ExportToExcel";

const OverallWarehouse = () => {
  const [stockData, setStockData] = useState();
  const [allData, setAllData] = useState([]);

  const { sendRequest: getWarehouseStock } = useHttp();

  useEffect(() => {
    const data = {
      orgId: localStorage.getItem("orgId"),
    };

    getWarehouseStock(
      {
        url: `/api/getOverallWarehouseStock/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        setStockData(res.warehouseStock);
        setAllData(res.warehouseStock);
      }
    );
  }, [getWarehouseStock]);

  const handleSearch = (e) => {
    const filtertext = e.target.value.trim().toLowerCase();
    
    const filterdata = allData.filter((item) => {
      // Ensure we convert all fields to strings and use .includes() only when valid
      return (
        (item?.itemId?.toString().toLowerCase().includes(filtertext)) ||
        (item?.productName?.toString().toLowerCase().includes(filtertext)) ||
        (item?.productTypeName?.toString().toLowerCase().includes(filtertext)) ||
        (item?.productSubTypeName?.toString().toLowerCase().includes(filtertext))
      );
    });
  
    setStockData(filterdata);
  };
  
  

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems =
    stockData && stockData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const fieldsToExport = [
    "itemId",
    "productName",
    "productSubTypeName",
    "productTypeName",
    "productQuantity",
    "unitAbbreviation",
    "productAmount",
    "minmax",
    "minimumQty",
    "notifierUnit",
  ];

  const customHeaders = [
    "Item id",
    "Product Name",
    "Product Item Sub Type",
    "Product Item Type",
    "Item Quantity",
    "Unit",
    "Amount",
    "Min/Max",
    "Minimum Notifier",
    "Minimum Notifier Unit",
  ];

  const handleExportExcel = () => {
    const filename = "overallWarehouseStock.xlsx";

    const transformedData = stockData.map((item) => ({
      ...item,
      minmax: item.minimumQty > item.productQuantity ? "Low" : "Ok",
      notifierUnit: item.minimumQty > 0 ? item.unitAbbreviation : " ",
    }));

    convertToExcel(transformedData, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-3 d-flex align-items-center">
            <label className="card-title mx-3 my-3">
              Overall Warehouse Stock
            </label>
          </div>
          {/* Search Box aligned to the right */}
          <div className="col-3 mt-3">
            <input
              type="text"
              name="q"
              className="form-control"
              placeholder="Search..."
              onKeyUp={(e) => handleSearch(e)}
            />
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="text-right my-2">
                      <button
                        type="button"
                        className="btn btn-sm btn-warning"
                        onClick={handleExportExcel}
                      >
                        <i className="fas fa-file-excel"></i>
                      </button>
                    </div>
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Item id</th>
                          <th>Product Name</th>
                          <th>Product Item Sub Type</th>
                          <th>Product Item Type</th>
                          <th>Item Quantity</th>
                          <th>Unit</th>
                          <th>Amount</th>
                          <th>Min/Max</th>
                          <th>Inv-Min Notifier</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.itemId}</td>
                                <td>{itm.productName}</td>
                                <td>{itm.productSubTypeName}</td>
                                <td>{itm.productTypeName}</td>

                                <td>{itm.productQuantity}</td>

                                <td>{itm.unitAbbreviation}</td>
                                <td>{itm.productAmount}</td>

                                <td>
                                  {itm.minimumQty > itm.productQuantity
                                    ? "Low "
                                    : "OK"}
                                </td>
                                <td>
                                  {itm.minimumQty} {itm.unitAbbreviation}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={(stockData && stockData.length) || 0}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default OverallWarehouse;
